/*
 * created by lzy
 * 新闻日历管理路由
 */
'use strict';
angular.module('newsCalendarManagementRouterModule', []).config(['$stateProvider', function($stateProvider) {
    $stateProvider.state('newscalendarmanagement', {
        url: '/newscalendarmanagement',
        views: {
            '': {
                templateUrl: './dateReminder/newsCalendarManagement/newsCalendarManagement.html',
                controller: 'newsCalendarManagementCtrl',
            },
        },
    })
}]);